<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <TextEditor
          title="Message"
          v-model="value.message"
          :table="table"
          :component="component"
          :containers="containers"
        />
      </v-col>
      <v-col cols="12">
        <v-select
          filled
          label="Type"
          hide-details
          v-model="value.type"
          :items="['info', 'error']"
        ></v-select>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TextEditor from "../shared/TextEditor.vue";

export default {
  name: "MessageDesigner",

  components: { TextEditor },

  props: ["value", "table", "component", "containers"],
};
</script>
